import React, { useState, useEffect, useCallback, useRef } from "react";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import AddUserCompany from "../../components/AddUserCompany";
import DeleteModal from "../../components/DeleteModal";
import AddElectronicSignature from '../../components/AddElectronicSignature';
import {
  faEdit,
  faTrashAlt,
  faSearch,
  faBuilding,
  faUserGear,
  faCircleCheck,
  faCircleXmark,
  faDatabase,
  faEllipsisH,
  faCircleArrowLeft,
  faSignature
} from "@fortawesome/free-solid-svg-icons";
import Table from "../../components/Table";
import Section from "../../components/Section";
import ValidateKPIModal from "../../components/ValidateKPIModal";
import apiClient from "../../axios";
import { Tooltip } from "react-tooltip";
import { useLocation, useNavigate } from "react-router-dom";

const CompaniesList = ({ handleLogout }) => {
  const location = useLocation();
  const { numCont } = location.state || {};
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const navigate = useNavigate();
  const [addUserModal, setAddUserModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [validateKpiVisible, setValidateKpiVisible] = useState(false);
  const dropdownRef = useRef(null);
  const [addElectronicS, setAddElectronicS,] = useState(false);
  const [mensage, setMensage] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
      const isDropdownItem = event.target.closest(".dm-class");

      if (!isClickInsideDropdown && !isDropdownItem) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hasPermission = (permission) => {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.includes(permission);
  };

  // Usa useCallback para memoizar fetchAllData
  const fetchAllData = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await apiClient.get(
          `/contracts/${numCont}/companies?page=${page}`
        );
        if (Array.isArray(response.data.results)) {
          setData(response.data.results);
          //setTotalItems(1);
          setTotalItems(response.data.total);
        } else {
          //setData([response.data]);
          setData([response.data.results]);
          setTotalItems(1);
        }
      } catch (error) {
        setIsErrorVisible(true);
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      } finally {
        setIsSuccessVisible(true);
        setLoading(false);
      }
    },
    [numCont]
  ); // Incluye numCont como dependencia

  useEffect(() => {
    fetchAllData(currentPage); // Llama a la función al cargar el componente
  }, [currentPage, fetchAllData, numCont]);

  const handleRefresh = () => {
    fetchAllData(currentPage);
  };

  const handleSearch = useCallback(
    async (page = 1) => {
      try {
        const params = new URLSearchParams();
        if (search) params.append("search", search);

        const response = await apiClient.get(
          `/contracts/${numCont}/companies?${params.toString()}&page=${page}`
        );

        if (Array.isArray(response.data.results)) {
          setData(response.data.results);
        } else {
          setData([response.data.results]);
        }
        setTotalItems(response.data.total);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setIsInfoVisible(true);
        }
      }
    },
    [search, numCont]
  );
  const handleFresh = async (code) => {
    handleSearch(1);
  };

  const handleCreateKPIConnection = async (item) => {
    try {
      const response = await apiClient.get(`/contracts/${item.contract}?module=APIKPI`);
      const modules = response.data.modules;
      if (modules && modules.length > 0) {
        navigate('/ConnectionKpiList', {
          state: {
            numCont: item.contract,
            companyId: item.id,

            companyRuc: item.ruc,
            companyName: item.name
          }
        });
      } else {
        setMensage("No es posible crear Conección , primero es necesario añadir el módulo [API KPI].")
        setValidateKpiVisible(true);
      }
    } catch (error) {
      setIsErrorVisible(true);
    }
  }

  const handleSignature = async (item) => {
    try {
      const response = await apiClient.get(`/contracts/${item.contract}?module=API_GEMA`);
      const modules = response.data.modules;
      if (modules && modules.length > 0) {
        setSelectedItem(item);
        setAddElectronicS(true);
      } else {
        setMensage("No es posible registrar la Firma Electrónica, primero es necesario añadir el módulo [API GEMA]")
        setValidateKpiVisible(true);
      }
    } catch (error) {
      setIsErrorVisible(true);
    }

  }
  const handleCloseSignature = () => {
    setAddElectronicS(false);
    setSelectedItem(null);
    handleRefresh()
  };

  const handleDeleteModal = (item) => {
    setSelectedDeleteItem(item);
    setDeleteItem(true);
  };
  const handleCloseDeleteModal = () => {
    setDeleteItem(false);
    setSelectedDeleteItem(null);
    handleRefresh();
  };

  const handleAddUser = (item) => {
    setSelectedItem(item);
    setAddUserModal(true);
  };
  const handleCloseAddUser = () => {
    setSelectedItem(null);
    handleRefresh();
  };

  const handleClick = () => {
    navigate(-1);
  };

  const columns = [
    { title: "Id", key: "id" },
    { title: "Contrato", key: "contract" },
    { title: "Nombre", key: "name" },
    { title: "Descripción", key: "descripction" },
    { title: "Secuencia", key: "sequence" },
    { title: "RUC", key: "ruc" },
    { title: "ESTADO", key: "status" },
    { title: "Acciones", key: "acciones" },
  ];

  const renderRow = (item, index) => (
    <>
      <td>{item.id}</td>
      <td>{item.contract}</td>
      <td>{item.name}</td>
      <td>{item.description}</td>
      <td>{item.sequence || "-"}</td>
      <td>{item.ruc}</td>
      <td>
        {!item.isClosed ? (
          <button className="status_button">
            <FontAwesomeIcon
              icon={faCircleCheck}
              style={{ color: "green", fontSize: "24px" }}
            />
          </button>
        ) : (
          <button className="status_button">
            <FontAwesomeIcon
              className="status_icon"
              icon={faCircleXmark}
              style={{ color: "red", fontSize: "24px" }}
            />
          </button>
        )}
      </td>
      <td>
        <div className="button-container">
          <div className="desktop-buttons">
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission("COMPANY_UPDATE") && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Editar"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/CompaniesForm/${item.id}`, {
                    state: { numCont: numCont },
                  });
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            )}
            <Tooltip id="delete-tooltip" className="custom-tooltip" />
            {hasPermission("COMPANY_DELETE") && (
              <button
                data-tooltip-id="delete-tooltip"
                data-tooltip-content="Eliminar"
                className="icon-button delete-button"
                //onClick={() => handleDelete(item.id)}
                onClick={() => handleDeleteModal(item)}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </button>
            )}
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission("COMPANY_ASSIGN") && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Usuarios"
                onClick={() => handleAddUser(item)}
              >
                <FontAwesomeIcon icon={faUserGear} />
              </button>
            )}
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
            {hasPermission('CREDENTIAL_KPI_CREATE') && (
              <button
                data-tooltip-id="edit-tooltip"
                className="icon-button edit-button"
                data-tooltip-content="Conexiones KPI"
                onClick={() => handleCreateKPIConnection(item)}
              >
                <FontAwesomeIcon
                  icon={faDatabase} />
              </button>
            )}
            {item.yesGema ? (
              <button
                //AQUI USUARIOS
                onClick={(e) => {
                  e.stopPropagation();
                  navigate('/ElectronicSignature', { state: { ruc: item.ruc, gemaId: item.gemaId, client: item.name } });
                }}
                data-tooltip-id="edit-tooltip"
                data-tooltip-content="Firma Electrónica Registrada."
                className="icon-button edit-button"

              >
                <FontAwesomeIcon
                  icon={faSignature}
                  style={{ color: 'green', fontSize: '15px' }}
                />
              </button>
            ) : (
              <button
                //AQUI CREAR
                onClick={(e) => {
                  e.stopPropagation();
                  handleSignature(item);
                }}
                data-tooltip-id="edit-tooltip"
                data-tooltip-content="No Cuenta con Firma E."
                className="icon-button edit-button"
              >
                <FontAwesomeIcon
                  icon={faSignature}
                  style={{ fontSize: '15px' }}
                />
              </button>
            )}
            <Tooltip id="edit-tooltip" className="custom-tooltip" />
          </div>

          <div className="mobile-dropdown">
            <div className="dropdown-container-contract">
              <button
                className="icon-button dropdown-button-contract"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDropdown(openDropdown === item.id ? null : item.id);
                }}
              >
                <FontAwesomeIcon icon={faEllipsisH} />
              </button>
              {openDropdown === item.id && (
                <div className="dropdown-menu-contract dm-class">
                  {hasPermission("COMPANY_UPDATE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/CompaniesForm/${item.id}`, {
                          state: { numCont: numCont },
                        });
                      }}
                    >
                      Editar
                    </button>
                  )}
                  {hasPermission("COMPANY_DELETE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        handleDeleteModal(item);
                        setOpenDropdown(false);
                      }}>
                      Eliminar
                    </button>

                  )}
                  {hasPermission("COMPANY_ASSIGN") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => {
                        handleAddUser(item);
                        setOpenDropdown(false);
                      }}>
                      Usuarios
                    </button>
                  )}
                  {hasPermission("CREDENTIAL_KPI_CREATE") && (
                    <button
                      className="dropdown-item-contract"
                      onClick={() => handleCreateKPIConnection(item)}>
                      Conexiones KPI
                    </button>
                  )}
                </div>

              )}
            </div>
          </div>
        </div>
      </td>
    </>
  );


  return (
    <div className="home-container">
      <Header onLogout={handleLogout} title="Compañías" />
      <div className="home-content">
        <Section>
          <div className="button-return-container">
            <div className="contener-return">
              <FontAwesomeIcon
                className="basic-shortcut-icon"
                style={{ cursor: "pointer" }}
                icon={faCircleArrowLeft}
                onClick={handleClick}
              />
            </div>
            <div className="filter-form">
              <div className="basic-info-form-group">
                <input
                  type="text"
                  id="customer"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Compañía"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleFresh();
                    }
                  }}
                />
              </div>
              <button className="basic-custom-button" onClick={handleFresh}>
                <FontAwesomeIcon
                  icon={faSearch}
                  className="basic-shortcut-icon"
                />
                Buscar
              </button>
            </div>
          </div>

          <div className="button-add">
            {hasPermission("COMPANY_CREATE") && (
              <button
                className="basic-custom-button"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate("/CompaniesForm", { state: { numCont: numCont } });
                }}
              >
                <FontAwesomeIcon
                  className="basic-shortcut-icon"
                  icon={faBuilding}
                />
                Crear Nueva Compañía
              </button>
            )}
          </div>
        </Section>
        <Table
          title="Lista de Compañías"
          rows={data}
          columns={columns}
          icon={faBuilding}
          renderRow={renderRow}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={setCurrentPage}
          onRefresh={handleRefresh}
          loading={loading}
          flagPagination={true}
        />
        <SuccessNotification
          message={"Se ha cargado correctamente"}
          isVisible={isSuccessVisible}
          onClose={() => setIsSuccessVisible(false)}
        />
        <ErrorNotification
          message="Ups! Ocurrió un Problema"
          isVisible={isErrorVisible}
          onClose={() => setIsErrorVisible(false)}
        />
        <LoginNotification
          message="Vuelve a iniciar sesión"
          isVisible={isInfoVisible}
          onClose={() => setIsInfoVisible(false)}
          onLogout={handleLogout}
        />
        {selectedItem && (
          <AddUserCompany
            isVisible={addUserModal}
            onClose={handleCloseAddUser}
            element={selectedItem}
          />
        )}
        {selectedDeleteItem && (
          <DeleteModal
            isVisible={deleteItem}
            onClose={handleCloseDeleteModal}
            identificator={selectedDeleteItem.id}
            url={`/admin/companies`}
          />
        )}
        <ValidateKPIModal
          message={mensage}
          isVisible={validateKpiVisible}
          onClose={() => setValidateKpiVisible(false)}
        />
        {addElectronicS && (
          <AddElectronicSignature
            isVisible={addElectronicS}
            onClose={handleCloseSignature}
            ruc={selectedItem.ruc}
            client={selectedItem.name}
            edit={false}
          />
        )}
      </div>
    </div>
  );
}

export default CompaniesList;
